var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgError(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.4619 6.39844C16.4272 6.39844 5.86048 16.9651 5.86048 29.9998C5.86048 43.0345 16.4272 53.6012 29.4619 53.6012C42.4966 53.6012 53.0633 43.0345 53.0633 29.9998C53.0633 16.9651 42.4966 6.39844 29.4619 6.39844ZM0.615723 29.9998C0.615723 14.0685 13.5306 1.15369 29.4619 1.15369C45.3932 1.15369 58.308 14.0685 58.308 29.9998C58.308 45.9311 45.3932 58.846 29.4619 58.846C13.5306 58.846 0.615723 45.9311 0.615723 29.9998Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.86048 29.9998C5.86048 16.9651 16.4272 6.39844 29.4619 6.39844C42.4966 6.39844 53.0633 16.9651 53.0633 29.9998C53.0633 43.0345 42.4966 53.6012 29.4619 53.6012C16.4272 53.6012 5.86048 43.0345 5.86048 29.9998Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7507 19.1976L40.2643 38.7112L38.1735 40.802L18.6599 21.2883L20.7507 19.1976Z",
    fill: "#F44336"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6599 38.7111L38.1735 19.1974L40.2643 21.2882L20.7507 40.8018L18.6599 38.7111Z",
    fill: "#F44336"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.2d0548008646ee3a8104701e81a8d6d9.svg";
export { ForwardRef as ReactComponent };